import { useRecoilValue } from 'recoil'
import { section } from '@/store/template/section'
import Wrapper from '@/components/onepager/sections/Wrapper'
import ShortText from '@/components/onepager/sections/ShortText'
import MultiShortText from '@/components/onepager/sections/MultiShortText'
import Tasks from '@/components/onepager/sections/Tasks'
import Cards from '@/components/onepager/sections/Cards'
import Table from '@/components/onepager/sections/Table'
import RichText from '@/components/onepager/sections/RichText'
import RichTextEditable from '@/components/onepager/sections/RichTextEditable'
import Image from '@/components/onepager/sections/Image'
import TextCallout from '@/components/onepager/sections/TextCallout'
import MultiChoice from '@/components/onepager/sections/MultiChoice'
import Resources from '@/components/onepager/sections/Resources'
import LongText from '@/components/onepager/sections/LongText'
import FlipCard from '@/components/onepager/sections/FlipCard'
import VideoSection from '@/components/onepager/sections/VideoSection'
import Audio from '@/components/onepager/sections/Audio'
import Headline from '@/components/onepager/sections/Headline'
import Button from '@/components/onepager/sections/Button'

function SectionWrapper({ id, wrapperId }) {
  const getSection = useRecoilValue(section(id))

  return (
    <>
      {getSection.type == 'wrapper' && (
        <Wrapper
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'shorttext' && (
        <ShortText
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'multishorttext' && (
        <MultiShortText
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'tasks' && (
        <Tasks
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'cards' && (
        <Cards
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'table' && (
        <Table
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'richtext' && (
        <RichText
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'richtexteditable' && (
        <RichTextEditable
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'image' && (
        <Image
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'button' && (
        <Button
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'textcallout' && (
        <TextCallout
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'multichoice' && (
        <MultiChoice
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'resources' && (
        <Resources
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'longtext' && (
        <LongText
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'flipcard' && (
        <FlipCard
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'video' && (
        <VideoSection
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'audio' && (
        <Audio
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {getSection.type == 'headline' && (
        <Headline
          id={id}
          contentID={getSection.contentID}
          sectionData={getSection}
          wrapperId={wrapperId}
        />
      )}

      {/* {JSON.stringify(getSection)} */}
    </>
  )
}

export default SectionWrapper
